import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * PasswordInput — reusable password field with show/hide (eye icon) toggle.
 * Used on every screen that collects a password: Register, Login, Reset Password,
 * Settings → Change Password (Doctrine v2.0 Registration & Subscription Flow).
 *
 * `testId` is applied to the actual <input> so existing selectors keep working.
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { testId, className = '', autoComplete = 'current-password', ...props },
  ref,
) {
  const [visible, setVisible] = useState(false);
  const toggleTestId = testId ? `${testId}-toggle` : 'password-toggle';
  return (
    <div className="relative">
      <input
        ref={ref}
        type={visible ? 'text' : 'password'}
        data-testid={testId}
        autoComplete={autoComplete}
        className={`zita-input w-full px-4 py-3 pr-11 text-sm ${className}`}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        onClick={() => setVisible((v) => !v)}
        data-testid={toggleTestId}
        className="absolute inset-y-0 right-0 flex items-center justify-center px-3 text-zita-mocha hover:text-zita-cocoa transition-colors"
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

export default PasswordInput;
